import React, { useEffect, useRef, useState } from "react";
import { IRateCardProps } from "../../types/propTypes";
import TariffBreakdownModal from "./TariffBreakdownModal";
import { Overlay, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const RateCard = ({
  price,
  kwh_label,
  unit,
  type_label,
  image,
  duration_label,
  otherPrices,
  holding,
  setShowTariffBreakdown,
  showTooltip,
  setShowTooltip,
  currentSlide,
  cardIndex,
  priceBreakdown,
}: IRateCardProps) => {
  const [showTariffBreakdownModal, setShowTariffBreakdownModal] =
    useState<boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowTooltip(true);
    }, 300);
    return () => clearTimeout(timeout);
  }, [currentSlide, cardIndex]);

  const { t } = useTranslation();

  const targetRef = useRef(null);

  const handleInfoClick = () => {
    setShowTariffBreakdownModal(true);
    setShowTariffBreakdown(true);
    setShowTooltip(false);
  };

  return (
    <>
      <div className="mainRate-card" style={{ position: "relative" }}>
        <div
          className={`text-center p-0 pt-2 ${
            holding ? "blurredcard" : "card border-0"
          }`}
        >
          <div className="row">
            <div className="col-7 d-flex justify-content-end p-0">
              <img
                src={image}
                style={{ height: "30px", width: "30px" }}
                className="charging-icon mr-2 mt-2"
                alt="tariff-component-icon"
              />
            </div>

            {otherPrices && otherPrices.length > 0 && (
              <div className="col-5 d-flex justify-content-end ps-0">
                <img
                  ref={targetRef}
                  src={require("../../assets/images/info.svg").default}
                  style={{ height: "25px", width: "25px" }}
                  className="charging-icon mr-2"
                  alt="tariff-component-icon"
                  onClick={handleInfoClick}
                />
                {showTooltip && (
                  <Overlay
                    target={targetRef.current}
                    show={true}
                    container={document.body}
                  >
                    <Tooltip
                      id="always-visible-tooltip"
                      className="custom-tooltip-box"
                    >
                      {t<string>(
                        "stationDetails.tariffDetailsModal.tooltipText"
                      )}
                    </Tooltip>
                  </Overlay>
                )}
              </div>
            )}
          </div>

          <div className="component-price mt-2">
            {price ? price : "-"}
            <span className="ml-1" style={{ color: " #929292" }}>
              {unit ? "/" : ""}
            </span>
            <span className="component-rate">{unit ? unit : ""}</span>
          </div>

          <div className="component-time-container">
            <div className="component-time">
              {duration_label ? duration_label : null}
            </div>
            <div className="component-time">{kwh_label ? kwh_label : null}</div>
          </div>

          <div className="component-name p-2 mt-1">
            {type_label ? type_label : "-"}
          </div>
        </div>
      </div>

      {showTariffBreakdownModal && (
        <TariffBreakdownModal
          showModal={showTariffBreakdownModal}
          onHide={() => {
            setShowTariffBreakdownModal(false);
            setShowTariffBreakdown(false);
          }}
          type={type_label}
          priceBreakdown={priceBreakdown}
          unit={unit}
        />
      )}
    </>
  );
};

export default RateCard;
